import React from "react";
import { Box, Pagination } from "@mui/material";

// El estilo de los botones (cuadrados, activo en verde) vive en el tema
// (MuiPaginationItem). Aqui solo se garantiza la alineacion a la derecha:
// `marginLeft:auto` la mantiene pegada al borde derecho tanto cuando se usa
// suelta como cuando va dentro de ListFooter (que ya es space-between).
export const PaginationComponent = ({ data, paginate, itemsperPage }) => {
  const pageNumber = [];

  for (let i = 0; i < Math.ceil(data.length / itemsperPage); i++) {
    pageNumber.push(i);
  }

  const handleChange = (event, value) => {
    paginate(value);
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", marginLeft: "auto" }}>
      <Pagination
        count={pageNumber.length}
        shape="rounded"
        onChange={handleChange}
      />
    </Box>
  );
};
